import React from 'react'
import RecordForm from '../../../../../../generic/universal-table/components/RecordForm/RecordForm'
import { CarUiRow } from '../types/carTable.types'

type CarFormProps = React.ComponentProps<typeof RecordForm<CarUiRow>>

// Thin module-named wrapper so AppModal has a stable `Children` seam (and a place for
// any future car-specific glue). All logic lives in the unified RecordForm.
const CarForm = (props: CarFormProps) => <RecordForm<CarUiRow> {...props} />

export default CarForm
